var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalXL',{attrs:{"closeable":true},on:{"abort":_vm.closeModal}},[(_vm.hasTicketIframe)?_c('prio-ticket-list',{attrs:{"iframe-url":_vm.ticketIframe}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }